module.exports = __webpack_public_path__ + "media/src/images/abouts/devices/03-80218118608a3ac3b1a9e80041d2a0c4.png";